import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SubCategoryLinks from '../../components/Categories/SubCategoryLinks';
import { categoryUrlSelector } from '../../../modules/selectors/url';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import _ from 'lodash';
import loadable from '@loadable/component';
import ServiceCategories from '../../components/ServiceCategories/ServiceCategories';
import { InternalLink } from '../../components/form-elements/Link';
import { selectSubLocation } from '../../../modules/actions/standort/subLocation';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import ContactTile from '../../components/ContactTile/ContactTile'
import { hideServiceFormSelector } from '../../../modules/selectors/standort/theme';
import { useSeoContext } from '../../context/SeoContext';
import SeoContainer from '../../components/SeoContainer/SeoContainer';
import TopSeller from '../../components/TopSeller/TopSeller';

const NotFound = loadable(() => import('../ErrorPages/NotFound/NotFound'));

function AreaSubLocation() {
    const dispatch = useDispatch();
    const subLocationUrl = useSelector(categoryUrlSelector);
    const markenStandort = useSelector(markenStandortSelector);
    const hideServiceForm = useSelector(hideServiceFormSelector);
    const { setHandleOwnSeo } = useSeoContext();

    const subLocation = useMemo(() => subLocationUrl && _.find(markenStandort.areaShopSubLocations, { subLocationUrl }), [
        markenStandort.areaShopSubLocations,
        subLocationUrl,
    ]);


    useEffect(() => {
        setHandleOwnSeo(true);

        return () => {
            setHandleOwnSeo(false);
        };
    }, [setHandleOwnSeo]);

    useEffect(() => {
        if (subLocation) {
            dispatch(selectSubLocation({ subLocation }));
        }
    }, [dispatch, subLocation]);

    if (!subLocation) {
        return (
            <>
                <BreadCrumbSelector additionalCrumbs={[{ label: '404', url: `/notFound` }]} />
                <NotFound />
            </>
        );
    }

    return (
        <>
            <BreadCrumbSelector
                additionalCrumbs={[{ label: `${subLocation.anschrift.firma} in ${subLocation.anschrift.ort}`, url: subLocationUrl }]}
            />
            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container">
                    <div className="uk-flex uk-flex-between">
                        <h1>
                            {subLocation.anschrift.firma} in {subLocation.anschrift.ort}
                        </h1>
                        <InternalLink to="/">
                            <i className="fa fa-retweet" aria-hidden="true" /> Standort wechseln
                        </InternalLink>
                    </div>

                    <ContactTile
                        location={subLocation}
                        additionalActions={
                            <div>
                                <InternalLink className="uk-flex" modifier="primary" hideArrow to="/ueberuns">
                                    Über {subLocation.anschrift.firma}
                                </InternalLink>
                            </div>
                        }
                    />


                </div>
            </section>

            <SeoContainer />
            {!hideServiceForm && <ServiceCategories />}
            <TopSeller />

            <SubCategoryLinks />
        </>
    );
}

export default AreaSubLocation;
